import { demoFile, component, variant, componentWithVariants } from "system/demo";
import { BasicTeaserScreen } from 'feature/teaser/basic-teaser';

demoFile('feature/teaser/basic-teaser');

const comment = {
    key: 1,
    from: 'a',
    text: 'I love Godzilla. He is so cute.',
    time: Date.now()
};

// Basic Teaser
componentWithVariants('BasicTeaserScreen', BasicTeaserScreen, {}, [
    variant(null, {
        state: {
            collections: {
                comment: [comment]
            }
        }
    }),
    variant('No Comments', {
        state: {
            collections: {
                comment: []
            }
        }
    })
]); 